import { GlyphSize, GlyphColor } from 'components/Glyph';
import { TextColor } from 'components/Text';

export default {
  ACTIVE_GLYPH_COLOR: 'mascot' as GlyphColor,
  COLOR: 'graphite' as TextColor,
  GLYPH_COLOR: 'graphite' as GlyphColor,
  GLYPH_SIZE: 'large' as GlyphSize,
};
